import ApiManager from '../../utils/ApiManager'
import _ from 'lodash'
import Constants from '@/utils/Constants'
import DownloadService from '@/utils/download'

const state = {
  message: {
    content: '',
    type: ''
  },
  condition: {},
  access_list: {
    loading: false,
    showFooter: false,
    showSelect: false,
    selectAll: false,
    totalItems: 0,
    rowsPerPage: null,
    headers: [],
    items: []
  }
}

const actions = {

  async detail ({ dispatch, state, commit }) {
    commit('setResponseType', 0)
    commit('setListLoading', true)
    const response = await ApiManager.request('AccessHistory').accessListList(state.condition)
    let type = 'success'
    if (response.data.code === Constants.ResponseCode.SUCCESS) {
      commit('setAccessList', response.data.data)
    } else if (response.data.code === Constants.ResponseCode.VALIDATE_ERROR) {
      type = 'error'
    }
    commit('setListLoading', false)
    commit('setMessage', { content: response.data.data.message, type: type })
  },

  async download ({ dispatch, state, commit }) {
    this.dispatch('loading/loadingPagePlus')
    commit('setResponseType', 1)
    const response = await DownloadService.download('accesslist', 'csv', (config) => {
      return ApiManager.request('AccessHistory').accessListList(state.condition, config)
    })
    if (response) {
      commit('setMessage', { content: response.message, type: 'error' })
    }
    this.dispatch('loading/loadingPageMinus')
  },
  /**
   * 月次報告書条件設定
   */
  async setCondition ({ state, commit }, condition) {
    commit('setCondition', condition)
  }
}

const mutations = {
  init (state, data) {
    state.message = {
      content: '',
      type: ''
    }
  },
  setCondition (state, condition) {
    state.condition = condition
  },
  setListLoading (state, data) {
    // Listローディング状態
    state.access_list.loading = data
  },
  setAccessList (state, data) {
    state.access_list.headers = _.map(data[0], (item, idx) => {
      return { text: item, align: 'start', value: data[1][idx], sortable: false }
    })
    if (data.length > 2) {
      state.access_list.items = _.map(_.slice(data, 2), (r) => {
        let item = {}
        _.each(data[1], (h, idx) => {
          item[h] = r[idx]
        })
        return item
      })
    }
  },
  setResponseType (state, responseType) {
    state.condition['response_type'] = responseType
  },
  setMessage (state, data) {
    state.message = data
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
